<template>
<div class="page page_order page_order_detail">
	<div class="list" v-if="orderDetail">
        <div class="item">
            <div class="item_t">
                <div class="item_t_t">
                    <!-- <img :src="orderDetail.orders_ticket.qrcode_url ? orderDetail.orders_ticket.qrcode_url: $publicData.defaultTouxiang" alt="" class="thumb" /> -->
                    <div class="title">次卡<span class="" >{{orderDetail.is_through_ticket==1?'(通票)':''}}</span></div>
                </div>
                <div class="status" >已支付</div>
            </div>
        </div>
        <!-- 订单信息 -->
        <div class="item item_order">
            <div class="title">订单信息</div>
            <div class="order">
                <div class="">订单号：{{ orderDetail.order_sn }}</div>
                <div class="" v-if="orderDetail.pay_order_num">支付订单号：{{ orderDetail.pay_order_num }}</div>
                <div class="">创建时间：{{ orderDetail.created_at }}</div>
                <div class="" v-if="orderDetail.pay_at == 2">付款时间：{{ orderDetail.pay_at }}</div>
            </div>
        </div>
		<!-- 次卡信息 -->
		<div class="item item_order">
            <div class="title">次卡信息</div>
			<div class="order">
                <div class="" v-if="orderDetail.cardname">卡名：{{ orderDetail.cardname}}</div>
                <div class="" v-if="orderDetail.venue_name">展馆： {{ orderDetail.venue_name }}</div>
				<div class="">是否通票： {{ orderDetail.is_through_ticket ? '是': '否' }}</div>
                <div class="">支付金额： {{ orderDetail.total_prices }} </div>
                <div class="">总次数： {{ orderDetail.total_times }} </div>
                <div class="">使用次数：{{ orderDetail.used_times }} </div>
            </div>
			<div class="" v-if="orderDetail.orders_ticket">
				<div class="order" v-for="item in orderDetail.orders_ticket" :key="item.id">
					<div class="">参观人员:{{ item.name }}</div>
					<div class="">票价:{{ '¥'+item.price }}</div>
					<div class="">使用状态:{{ item.is_used ? '已用' : '待用' }}</div>
				</div>
			</div>
        </div>
        <!-- 操作 -->
		<!-- 订单详情里不加支付 -->
        <!-- <div class="actions">
            <div class="action" v-if="orderDetail.pay_status != 2 && orderDetail.order_type != 2">付款</div>
        </div> -->
    </div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			orderDetail: null, // 订单详情
			order_sn: this.$route.query.order_sn, // 订单号
            times_card_id: this.$route.query.times_card_id, // 次卡id
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '订单详情',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.getData()
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.getData()
        }
    },
	mounted() {
	},
    methods: {
		// 获取订单详情
		getData(){
			var that = this
			var params = {
				token: that.token,
				order_sn: that.order_sn,
                times_card_id: that.times_card_id
			}
			that.$api.smartpark.usertimescarddetail(params).then(res=>{
				if(res.code == 200){
					that.orderDetail = res.result
				}
			})
		},
		// 支付
		// toPay(order){
		// 	var that = this
        //     if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
        //         var params = {
		// 			'data': {
		// 				'url': that.$publicData.clientUrl + '/smartpark/pay?pay_order_num='+order.pay_order_num+'&price'+order.total_price
		// 				}
		// 			}
		// 		that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

		// 		})
        //     } else {
        //         that.$router.push({
        //             path: '/smartpark/pay',
        //             query: {
        //                 pay_order_num: order.pay_order_num,
        //                 price: order.total_price,
        //             }
        //         })
        //     }
			
		// }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
